import React from 'react';
import PropTypes from 'prop-types';

import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ManagedInput from 'components/form/managed_input';

import './styles.scss';

export default function Header({ deals, selectedDeal, onDealChange }) {
  if (!selectedDeal) {
    return null;
  }

  return (
    <div className="d-flex justify-content-between mx-4">
      <div className="selected-deal">
        <ManagedInput
          aria-label="dealSidebarSelect"
          className="form-control"
          name="selectedDeal"
          type="select"
          value={selectedDeal.id}
          onValueChange={id => onDealChange(deals.find(deal => deal.id === parseInt(id)))}
        >
          {deals.map(deal => (
            <option key={deal.id} value={deal.id}>
              {deal.displayName}
            </option>
          ))}
        </ManagedInput>
      </div>
      {!selectedDeal?.parent && selectedDeal?.path && (
        <h4 className="d-flex">
          <a aria-label="dealSidebarLink" href={selectedDeal.path}>
            View Deal <FontAwesomeIcon className="ml-2" icon={faAngleRight}/>
          </a>
        </h4>
      )}
    </div>
  );
}

Header.propTypes = {
  deals: PropTypes.arrayOf(PropTypes.object),
  selectedDeal: PropTypes.object,
  onDealChange: PropTypes.func.isRequired,
};
